import { render } from "./PricingCard.vue?vue&type=template&id=24d9541a"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"

import "./PricingCard.vue?vue&type=style&index=0&id=24d9541a&lang=scss"
script.render = render

export default script